import {
  LRS_PREVIEW_URL,
  LRS_URL,
  MOBILE_SIGN_LINK_URL,
} from 'constants/config';
import type { PreviousPayment } from 'models/lrs';
import { fetchJson } from 'utils/fetchJson/fetchJson';

type UploadLrsRequestBody = {
  paymentId: string;
  paymentToken: string;
  bankAccountNumber: string;
  studentFullName: string;
  studentID: string;
  transactions: PreviousPayment[];
  signatureImage: string;
};

type MobileSignLink = {
  url: string;
  expiresAt: string;
};

type PreviewFormRequestBody = {
  paymentId: string;
  paymentToken: string;
  bankAccountNumber?: string;
  studentFullName?: string;
  studentID?: string;
  transactions?: PreviousPayment[];
};

export const lrs = {
  fetchMobileSignLink: () =>
    fetchJson<MobileSignLink>(MOBILE_SIGN_LINK_URL, { method: 'GET' }),

  upload: (payload: UploadLrsRequestBody) => {
    const body = JSON.stringify({
      payment_id: payload.paymentId,
      payment_token: payload.paymentToken,
      bank_account_number: payload.bankAccountNumber,
      student_full_name: payload.studentFullName,
      student_id: payload.studentID,
      transactions: parseTransactions(payload.transactions),
      signature_image: payload.signatureImage,
    });

    return fetchJson<void>(`${LRS_URL}/upload`, { method: 'POST', body });
  },

  previewForm: (payload: PreviewFormRequestBody) => {
    const body = JSON.stringify({
      payment_id: payload.paymentId,
      payment_token: payload.paymentToken,
      bank_account_number: payload.bankAccountNumber,
      student_full_name: payload.studentFullName,
      student_id: payload.studentID,
      transactions: parseTransactions(payload.transactions),
    });

    return fetch(LRS_PREVIEW_URL, { method: 'POST', body }).then(response =>
      response.arrayBuffer(),
    );
  },

  delete: ({
    paymentId,
    paymentToken,
  }: {
    paymentId: string;
    paymentToken: string;
  }) => {
    const options = { method: 'DELETE' };

    const url = `${LRS_URL}/${paymentId}?payment_token=${paymentToken}`;

    return fetch(url, options);
  },
};

const parseTransactions = (transactions: PreviousPayment[] = []) => {
  if (!transactions.length) {
    return null;
  }

  return transactions.map(({ adBranch, ...transaction }) => ({
    ...transaction,
    address: adBranch,
  }));
};
